var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_661_18226)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4316 15.875C19.8103 15.875 19.3066 16.3787 19.3066 17V19C19.3066 19.2321 19.2145 19.4546 19.0504 19.6187C18.8863 19.7828 18.6637 19.875 18.4316 19.875H6.43164C6.19958 19.875 5.97702 19.7828 5.81292 19.6187C5.64883 19.4546 5.55664 19.2321 5.55664 19V17C5.55664 16.3787 5.05296 15.875 4.43164 15.875C3.81032 15.875 3.30664 16.3787 3.30664 17V19C3.30664 19.8288 3.63588 20.6237 4.22193 21.2097C4.80798 21.7958 5.60284 22.125 6.43164 22.125H18.4316C19.2604 22.125 20.0553 21.7958 20.6413 21.2097C21.2274 20.6237 21.5566 19.8288 21.5566 19V17C21.5566 16.3787 21.053 15.875 20.4316 15.875Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2291 16.7955C12.7897 17.2348 12.0774 17.2348 11.6381 16.7955L6.6381 11.7955C6.19876 11.3562 6.19876 10.6438 6.6381 10.2045C7.07744 9.76517 7.78975 9.76517 8.22909 10.2045L12.4336 14.409L16.6381 10.2045C17.0774 9.76517 17.7897 9.76517 18.2291 10.2045C18.6684 10.6438 18.6684 11.3562 18.2291 11.7955L13.2291 16.7955Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4297 17.125C11.8084 17.125 11.3047 16.6213 11.3047 16V4C11.3047 3.37868 11.8084 2.875 12.4297 2.875C13.051 2.875 13.5547 3.37868 13.5547 4V16C13.5547 16.6213 13.051 17.125 12.4297 17.125Z",
    fill: "#4B4AD5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_661_18226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24.4316 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPurple);
export default __webpack_public_path__ + "static/media/download-purple.1b68df52f30f19cbae6a79da7ebaf314.svg";
export { ForwardRef as ReactComponent };